import { css } from '@emotion/react';
import { tokens, applyFont } from '@domain-group/fe-brary';

const { neutral } = tokens.colors;

export const cardWrapper = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
`;

export const imageWrapper = css`
  width: 100%;
  height: 160px;
  position: relative;
  display: block;
  overflow: hidden;
  border-radius: ${tokens.borderRadius.outer};
  transition: outline-color 150ms ease;
  outline: 2px solid transparent;

  a:focus-visible & {
    outline-color: ${tokens.colors.interactive.base.default};
  }
`;

export const image = css`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transition: transform 0.3s ease;
`;

export const articleLink = css`
  display: flex;
  flex-direction: column;
  text-decoration: none;
  width: 100%;
  gap: ${tokens.spacing.s};
  outline: none;

  &:hover img {
    transform: scale(1.05);
  }
`;

export const articleInfo = css`
  text-align: left;
  padding: 0 ${tokens.spacing.xxs};
`;

export const title = css`
  ${applyFont(tokens.typography.overline)}
  color: ${neutral.medium.default};
  text-transform: uppercase;
  transition: color 0.3s ease;

  a:hover &,
  a:focus-visible & {
    color: ${tokens.colors.interactive.base.default};
  }
`;

export const subTitle = css`
  ${applyFont(tokens.typography.body)}
  color: ${neutral.heavy.default};
  margin-top: ${tokens.spacing.xs};
  transition: color 0.3s ease;

  a:hover &,
  a:focus-visible & {
    color: ${tokens.colors.interactive.base.default};
  }
`;
